function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_7553_821)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 31.3496,
  y: 87.6426,
  width: 16.5598,
  height: 9.4893,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 13.123,
  y: 40.647,
  width: 22.7856,
  height: 15.0712,
  rx: 3,
  fill: "#98C8FF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 39.6309,
  y: 21.9619,
  width: 55.8194,
  height: 75.1701,
  rx: 10,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5127 40.647H39.6306V88.5731C39.6306 93.3001 35.7987 97.132 31.0717 97.132C26.3447 97.132 22.5127 93.3 22.5127 88.5731V40.647Z",
  fill: "url(#paint0_linear_7553_821)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 47.9035C8 43.8958 11.2489 40.647 15.2565 40.647C19.2642 40.647 22.513 43.8958 22.513 47.9035V84.3722H18C12.4772 84.3722 8 79.895 8 74.3722V47.9035Z",
  fill: "url(#paint1_linear_7553_821)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 47.0723,
  y: 58.1763,
  width: 40.9342,
  height: 14.2485,
  rx: 4,
  fill: "#99C9FF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 47.0723,
  y: 77.1157,
  width: 21.7696,
  height: 8.9311,
  rx: 3,
  fill: "#99C9FF"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7553_821)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M58.0442 30.3013C52.2244 30.3013 47.501 35.0247 47.501 40.8445C47.501 46.6644 52.2244 51.3878 58.0442 51.3878C63.8641 51.3878 68.5875 46.6644 68.5875 40.8445C68.5875 35.0247 63.8641 30.3013 58.0442 30.3013ZM58.0442 33.4642C59.7944 33.4642 61.2072 34.877 61.2072 36.6272C61.2072 38.3774 59.7944 39.7902 58.0442 39.7902C56.2941 39.7902 54.8813 38.3774 54.8813 36.6272C54.8813 34.877 56.2941 33.4642 58.0442 33.4642ZM58.0442 48.4357C55.4084 48.4357 53.0784 47.0862 51.7183 45.0408C51.7499 42.9426 55.9356 41.7934 58.0442 41.7934C60.1424 41.7934 64.3386 42.9426 64.3702 45.0408C63.0101 47.0862 60.6801 48.4357 58.0442 48.4357Z",
  fill: "#83BEFF"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_7553_821)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 72.835,
  y: 6.04541,
  width: 30.3438,
  height: 17.3945,
  rx: 6,
  fill: "#F94545"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.6045 25.8013C89.4498 27.8013 86.5631 27.8013 85.4084 25.8013L83.8257 23.06C82.671 21.06 84.1144 18.56 86.4238 18.56L89.5891 18.56C91.8985 18.56 93.3419 21.06 92.1872 23.06L90.6045 25.8013Z",
  fill: "#F94545"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.125 19.925C87.8083 19.925 87.5583 19.825 87.375 19.625C87.2083 19.425 87.1083 19.1417 87.075 18.775L86.325 9.225C86.275 8.60833 86.4083 8.11667 86.725 7.75C87.0417 7.36667 87.5083 7.175 88.125 7.175C88.725 7.175 89.175 7.36667 89.475 7.75C89.7917 8.11667 89.925 8.60833 89.875 9.225L89.125 18.775C89.1083 19.1417 89.0083 19.425 88.825 19.625C88.6583 19.825 88.425 19.925 88.125 19.925ZM88.125 25.125C87.5583 25.125 87.1 24.95 86.75 24.6C86.4167 24.25 86.25 23.8 86.25 23.25C86.25 22.7167 86.4167 22.2833 86.75 21.95C87.1 21.6 87.5583 21.425 88.125 21.425C88.7083 21.425 89.1583 21.6 89.475 21.95C89.8083 22.2833 89.975 22.7167 89.975 23.25C89.975 23.8 89.8083 24.25 89.475 24.6C89.1583 24.95 88.7083 25.125 88.125 25.125Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_7553_821",
  x: 0,
  y: 17.9619,
  width: 103.45,
  height: 91.1699,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7553_821"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7553_821",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_7553_821",
  x: 64.835,
  y: 2.04541,
  width: 46.3438,
  height: 37.2559,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7553_821"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7553_821",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7553_821",
  x1: 23.6291,
  y1: 40.647,
  x2: 39.6306,
  y2: 97.132,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#99C9FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#62AEFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_7553_821",
  x1: 8,
  y1: 50.4546,
  x2: 22.513,
  y2: 57.8972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6AABFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4B82F8"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7553_821"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25.3038,
  height: 25.3038,
  fill: "white",
  transform: "translate(45.3926 28.1924)"
})));

function SvgNotFoundError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 110,
    viewBox: "0 0 112 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundError);
export default __webpack_public_path__ + "static/media/NotFoundError.515345d3.svg";
export { ForwardRef as ReactComponent };